import "./Shopping.scss";
import React from "react";
import data from "../../utils/datas";
import Products from "../../components/Products/Products";
import Filter from "../../components/Filter/Filter";
import Cart from "../../components/Cart/Cart";
import axios from "axios";
import { API_URL } from "../../utils/axios";
import { Redirect } from "react-router-dom";

class Shopping extends React.Component {
  constructor() {
    super();
    this.state = {
      submittedForm: false,
      products: data.products,
      cartItems: localStorage.getItem("cartItems")
        ? JSON.parse(localStorage.getItem("cartItems"))
        : [],
      type: "",
      sort: "",
    };
  }

  createOrder = (order) => {
    const detailsTitles = order.cartItems
      .map((item) => {
        return `Item: ${item.title}, Quantity: ${item.count}\n`;
      })
      .join("");

    const custom = {
      quantity: order.cartItems
        .map((a) => {
          return a.count;
        })
        .reduce((a, b) => a + b),
      name: order.name,
      email: order.email,
      phone: order.number,
      date: order.date,
      selection: "See details",
      details: detailsTitles,
    };

    axios
      .post(API_URL + "/order/quotes", {
        ...custom,
      })
      .then((response) =>
        this.setState({
          submittedForm: true,
        })
      )
      .catch((error) => console.log(error));
  };

  removeFromCart = (product) => {
    const cartItems = this.state.cartItems.slice();
    this.setState({
      cartItems: cartItems.filter((x) => x.id !== product.id),
    });
    localStorage.setItem(
      "cartItems",
      JSON.stringify(cartItems.filter((x) => x.id !== product.id))
    );
  };

  addToCart = (product) => {
    const cartItems = this.state.cartItems.slice();
    let alreadyInCart = false;
    cartItems.forEach((item) => {
      if (item.id === product.id) {
        item.count++;
        alreadyInCart = true;
      }
    });
    if (!alreadyInCart) {
      cartItems.push({ ...product, count: 1 });
    }
    this.setState({ cartItems });
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  };

  sortProducts = (event) => {
    const sort = event.target.value;
    this.setState((state) => ({
      sort: sort,
      products: this.state.products
        .slice()
        .sort((a, b) =>
          sort === "lowest"
            ? a.price > b.price
              ? 1
              : -1
            : sort === "highest"
            ? a.price < b.price
              ? 1
              : -1
            : a.id < b.id
            ? 1
            : -1
        ),
    }));
  };

  filterProducts = (event) => {
    console.log(event.target.value);
    if (!event.target.value) {
      this.setState({ type: "", products: data.products });
    } else {
      this.setState({
        type: event.target.value,
        products: data.products.filter(
          (product) => product.type === event.target.value.toLowerCase()
        ),
      });
    }
  };
  render() {
    if (this.state.submittedForm) {
      return <Redirect to="/sent" />;
    }
    return (
      <div>
        <h1 className="shopping__title">Staples</h1>
        <div className="shopping">
          <div className="shopping__products">
            <Filter
              count={this.state.products.length}
              type={this.state.type}
              sort={this.state.sort}
              filterProducts={this.filterProducts}
              sortProducts={this.sortProducts}
            />
            <Products
              products={this.state.products}
              addToCart={this.addToCart}
            />
          </div>
          <div className="shopping__cart">
            <Cart
              cartItems={this.state.cartItems}
              removeFromCart={this.removeFromCart}
              createOrder={this.createOrder}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Shopping;
